export const GET_STATEMENTS = 'GET_STATEMENTS'
export const CLEAR_STATEMENTS = 'CLEAR_STATEMENTS'
export const SET_DOWLOAD_STATEMENT_IN_PROGRESS = 'SET_DOWLOAD_STATEMENT_IN_PROGRESS'
export const SET_DOWNLOAD_STATEMENT_PROCESS_ID = 'SET_DOWNLOAD_STATEMENT_PROCESS_ID'
